<template>
	<div id="page">

		<div class="page-content">
			<div class="page-title page-title-small mb-3">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					کاربران
					<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>

			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>
			<template v-if="isMinVersion==true">
				<div class="card card-style">
					<div class="content">
						<!--<p class="text-justify mb-0 pt-0">
							در این لیست فقط
							<b class="text-danger">کابران دارای اشتراک</b>
							قابل مشاهده هستند. برای دسترسی به
							<b>لیست تمام کاربران</b>
							به قسمت
							<b class="text-danger">تمدید اشتراک</b>
							مراجعه نمایید.
						</p>-->
						<router-link to="/Order" class="btn btn-xxs btn-full bg-green1-light rounded-sm text-uppercase font-900 w-100" v-if="isAdmin==true || isFreeRegist">
							<i class="fa fa-user-clock ml-2"></i>
							تهیه اشتراک
						</router-link>
						<router-link to="/UserOrder" class="btn btn-xxs btn-full bg-green1-light rounded-sm text-uppercase font-900 w-100" v-else>
							تهیه اشتراک
						</router-link>
					</div>
				</div>
			</template>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="list-group list-custom-small list-icon-0">
						<div class="list-group-div" v-for="task in LocalUserListList" :key="task.userId">
							<div @click.prevent="openDetails(task)">
								<div class="d-flex justify-content-between mt-2">
									<span class="d-inline-flex align-items-center">
										<!--اگر کاربر تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user color-green2-light"></i>-->
										<!--تصویر پروفایل کاربر-->
										<img v-if="task.userImg!=null && task.userImg!=''" :src="task.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>
										<span>{{task.title}}</span>
									</span>
								</div>
								<div>
									<i class="fa fa-sitemap brand-color"></i>
									<span>{{task.orgJobTitle}}</span>
								</div>
								<div class="d-flex align-items-center mb-2">
									<span class="text-muted ml-2"> وضعیت</span>
									<div class="ml-1">
										<div v-if="task.disabled==true">
											<span class="text-muted"></span><span class="badge bg-red2-dark position-static mt-0">غیرفعال</span>
										</div>
										<div v-if="task.disabled==false">
											<span class="text-muted"></span><span class="badge bg-green1-dark position-static mt-0">فعال</span>
										</div>
									</div>
									<div class="ml-1">
										<span v-if="task.mainUser" class="badge bg-magenta2-light position-static mt-0">کاربر مجموعه</span>
										<span v-if="!task.mainUser" class="badge bg-magenta2-light position-static mt-0">کاربر دعوت شده</span>
									</div>
									<div class="ml-1" v-if="task.expired==true">
										<span class="badge bg-red2-dark position-static mt-0">نیاز به تهیه اشتراک</span>
									</div>
								</div>
							</div>

							<!--<router-link v-if="!task.deleted" :to="{ name: 'DeleteUser', params: { code: task.userCode  } }" class="btn btn-xxs btn-full border-red2-dark color-red2-dark rounded-sm btn-border font-900 mb-3" style="border-bottom: 1px solid #da4453!important">
								<i class="fa fa-user-times color-red2-dark ml-2 float-none opacity-1 line-height-s" style="width:auto!important;height:auto!important"></i>
								حذف حساب کاربری
							</router-link>-->


						</div>
						<div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
							<div class="spinner-border color-magenta2-dark" role="status"></div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'EditUser', params: { userId: selectedTypeId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
		<!--<div id="localUserListHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>

					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-LocalUserList.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-LocalUserList.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->

	</div>



</template>

<script>
	import VueSimpleAlert from "vue3-simple-alert";

	import HelpMenu from '../Components/HelpMenu.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu
		},
		data() {
			return {
				showInBazar: false,
				page: 1,
				filterId: 0,
				searchKey: "",
				selectedTypeId: 0,
				pageLoaded: false
			};
		},
		computed: {
			LocalUserListList() {
				return this.$store.getters.GetLocalUserListList;
			},
			isFreeRegist() {
				return this.$store.getters.GetIsFreeRegist;
			},
			isAdmin() {
				return this.$store.getters.GetIsAdmin;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			}
		},

		created() {
			//this.$http
			//    .get("Task/GetPayInBazar")
			//    .then((data) => {
			//        var res = data.data;
			//        this.showInBazar = res.isSuccess;
			//    });
			this.$store.dispatch("GetLocalUserListListFromServer", {
				pageId: this.page,
				filterId: this.filterId,
				searchKey: this.searchKey
			});
		},
		methods: {

			showMenu(userId) {
				this.selectedTypeId = userId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			filterList() {
				this.page = 1;
				this.$store.dispatch("GetLocalUserListListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					searchKey: this.searchKey
				});
			},
			openDetails(user) {
				if (user.mainUser) {
					this.$router.push({ name: 'EditUser', params: { userId: user.userId } });
					document.getElementsByClassName('menu-hider')[0].click();
				} else {
					VueSimpleAlert.alert("به ویرایش اطلاعات کاربر دعوت شده دسترسی ندارید", null, "warning", { confirmButtonText: "تایید" });
				}
			},
			getNextPageForLocalUserListList() {
				this.page++;
				this.$store.dispatch("GetLocalUserListListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					searchKey: this.searchKey
				});
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

			console.log("mounted");
			this.getNextPageForLocalUserListList();

		}
	};
</script>
